import {
  QueryClient,
  QueryClientProvider,
  QueryClientProviderProps,
} from "@tanstack/react-query";

const queryClient = new QueryClient();

export const ReactQueryProvider = (
  props: Omit<QueryClientProviderProps, "client">,
) => {
  return <QueryClientProvider {...props} client={queryClient} />;
};
